import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import Error404 from '../../Error404';
import { MODULES_KEY, PERMISSION_OBJECT, ROUTES } from '../../common/constants';
import './aos.less';
import AttendanceTrackerWrapper from './attendance-tracker';
import PodDetail from './pods/PodDetail';
import Pods from './pods/Pods';
import Streams from './streams/Streams';

const AosWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.AOS_STREAMS}/:podId/detail`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.AOS_PODS}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <PodDetail {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.AOS_STREAMS}/:streamId`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.AOS_PODS}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Pods {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={ROUTES?.AOS_STREAMS}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.AOS_PODS}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Streams {...props} />
        </AccessControl>
      )}
    />
    <Route
      path={ROUTES?.AOS_ATTENDANCE_TRACKER}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.AOS_ATTENDANCE_TRACKER}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <AttendanceTrackerWrapper {...props} />
        </AccessControl>
      )}
    />
    <Route path="*" component={Error404} />
  </Switch>
);

export default AosWrapper;
